import { createAction } from "../../actions/actionUtils.js";
import {
  API_SUCCESS,
  API_RESET,
  API_ERROR,
  API_ERROR_MODAL,
  API_ERROR_RESET,
  API_ERROR_NEXT
} from "../../actions/actionConstants.js";

export const apiReset = () => createAction(API_RESET);
export const apiSuccess = (requestAction, result) =>
  createAction(API_SUCCESS, { requestAction, result });

// used to store error data
export const apiError = (error, isFatal) => {
  return {
    type: API_ERROR,
    payload: {
      ...error,
      isFatal: isFatal === true
    }
  };
};

export const showError = () => createAction(API_ERROR_MODAL);
export const nextError = () => createAction(API_ERROR_NEXT);
export const dismissError = () => createAction(API_ERROR_RESET);
export const resetErrors = () => createAction(API_ERROR_RESET);

export default {};
